<main class="method-page">
  <header>
    <p class="eyebrow">TENANT CONFIGURATION / PLANNING</p>
    <h1>Promotion planning method</h1>
    <p>Choose the planning workspace used by this tenant. Existing catalogue pages remain saved if you switch methods.</p>
  </header>

  <div *ngIf="loading" class="method-loading" aria-label="Loading planning settings">
    <dx-load-indicator [visible]="true"></dx-load-indicator>
  </div>

  <section *ngIf="!loading && error" class="settings-error">
    <strong>Settings unavailable</strong>
    <p>{{ error }}</p>
    <dx-button text="Retry" type="default" (onClick)="load()"></dx-button>
  </section>

  <section *ngIf="!loading && !error" class="method-card">
    <dx-radio-group
      class="method-options"
      [items]="options"
      valueExpr="value"
      displayExpr="text"
      itemTemplate="methodOption"
      [value]="method"
      (valueChange)="selectMethod($event)"
      [disabled]="!canManage || saving">
      <div *dxTemplate="let option of 'methodOption'" class="method-choice">
        <strong>{{ option.text }}</strong>
        <small>{{ option.description }}</small>
      </div>
    </dx-radio-group>

    <section *ngIf="blockingPromotions.length" class="blocking" role="alert">
      <strong>Catalogue planning can't be turned on yet</strong>
      <p>{{ saveError }}</p>
      <p *ngIf="blockingCount > blockingPromotions.length" class="blocking-count">
        Showing {{ blockingPromotions.length }} of {{ blockingCount }} blocking promotions.
      </p>
      <dx-data-grid
        class="blocking-grid"
        [dataSource]="blockingPromotions"
        keyExpr="id"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="true">
        <dxi-column dataField="description" caption="Promotion"></dxi-column>
        <dxi-column dataField="promotion_start" caption="Start" dataType="date" format="dd-MM-yyyy"></dxi-column>
        <dxi-column dataField="promotion_end" caption="End" dataType="date" format="dd-MM-yyyy"></dxi-column>
        <dxi-column dataField="status" caption="Status"></dxi-column>
      </dx-data-grid>
    </section>

    <div class="method-footer">
      <span *ngIf="saved" class="saved">Configuration saved.</span>
      <span *ngIf="saveError && !blockingPromotions.length" class="error" role="alert">{{ saveError }}</span>
      <dx-button
        class="save-method"
        type="default"
        [text]="saving ? 'Saving…' : 'Save planning method'"
        [disabled]="!canManage || saving || !dirty"
        (onClick)="save()">
      </dx-button>
    </div>
  </section>

  <aside class="method-note">
    <strong>Tenant-scoped setting</strong>
    <span>This choice changes navigation and the promotion’s information action. It does not migrate or delete existing promotion details.</span>
  </aside>
</main>
